import React, { createContext, useContext } from 'react';
import User from '../models/User';

export interface UserContextValue {
  user: User | null | false;
  setCurrentUser: (user: any) => void;
}

const defaultContextValue: UserContextValue = {
  user: null,
  setCurrentUser: () => {},
};

const UserContext = createContext<UserContextValue>(defaultContextValue);

export const useUserContext = () => useContext(UserContext);

export default UserContext;
